module.exports = __webpack_public_path__ + "static/cebra-f694f7802d83f3be664159d84ff58650.jpg";